import React, { useEffect, useState } from 'react';

import { Grid, makeStyles } from '@material-ui/core';

import Table from '../common/Table';

const useStyles = makeStyles((theme) => ({
  table: {
    '& .MuiTableCell-head': {
      paddingTop: 0,
    },
    borderRight: '1px solid #E7E7E7',
    marginRight: '1.5rem',
    marginTop: '1rem',
    paddingRight: '1.5rem',
    width: '100%',
  },
  workspaceName: {
    color: theme.palette.primary.main,
    cursor: 'pointer',
    textDecoration: 'underline',
  },
}));
function getColumns(onWorkspaceClick, classes) {
  return [
    {
      label: 'Name',
      name: 'name',
      options: {
        customBodyRender: (value, meta) => {
          const id = meta.rowData[3];
          return (
            <a className={classes.workspaceName} aria-hidden="true" onClick={() => onWorkspaceClick(id)} onKeyDown={() => onWorkspaceClick(id)}>
              {value}
            </a>
          );
        },
      },
      sort: true,
    },
    {
      label: 'Creators',
      name: 'creatorType',

      options: {
        customBodyRender: (value) => (value === 'own' ? 'Clinic only' : 'Mediphany / Clinic'),
      },
    },
    {
      label: 'Case Creation',
      name: 'caseCreationType',
      options: {
        customBodyRender: (value) => (value === 'manual_entry' ? 'Manual' : 'Ambra'),
      },
    },
    {
      label: '',
      name: 'id',
      options: { display: false },
    },
  ];
}

export default ({ workspaces, onCriteriaChange, onWorkspaceClick, total }) => {
  const classes = useStyles();
  const columns = getColumns(onWorkspaceClick, classes);

  const defaultOptions = (currentWorkspaces) => ({
    onRowSelectionChange: (currentRowsSelected) => {
      const { id } = currentWorkspaces[currentRowsSelected[0].index] || {};
      if (!id && id !== 0) return;

      setSelectedRow([currentRowsSelected[0].index]);
      onWorkspaceClick(id);
    },
    onTableChange: (action, tableState) => {
      const criteria = {};
      switch (action) {
        case 'sort':
          criteria.orderType = tableState.sortOrder.direction.toUpperCase();
          criteria.orderField = tableState.sortOrder.name;
          break;
        case 'changePage':
          criteria.page = tableState.page;
          break;
        case 'changeRowsPerPage':
          criteria.limit = tableState.rowsPerPage;
          tableOptions.rowsPerPage = tableState.rowsPerPage;
          break;
        default:
          return;
      }
      onCriteriaChange(criteria);
    },
    rowsSelected: [0],
    serverSide: true,
  });

  const [selectedRow, setSelectedRow] = useState([0]);
  const [tableOptions, setTableOptions] = useState(defaultOptions(workspaces));

  const setCurrentWorkspace = () => {
    const currentWorkspace = workspaces[selectedRow[0]];

    if (!currentWorkspace) return;

    onWorkspaceClick(currentWorkspace.id);
  };

  useEffect(() => {
    setTableOptions({ ...tableOptions, rowsSelected: selectedRow });
    setCurrentWorkspace();
  }, [selectedRow]);

  useEffect(() => {
    setTableOptions((tableOptions) => ({
      ...tableOptions,
      onRowSelectionChange: (currentRowsSelected) => {
        setSelectedRow([currentRowsSelected[0].index]);
      },
    }));
  }, [workspaces, onWorkspaceClick]);

  useEffect(() => {
    setTableOptions({
      ...tableOptions,
      count: total,
    });
  }, [total]);

  return (
    <Grid container>
      <Table className={classes.table} columns={columns} data={workspaces || []} options={tableOptions} />
    </Grid>
  );
};
